import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule,Routes } from '@angular/router';
import { MemberDetailsComponent } from './member-details/member-details.component';
import { MembersListingComponent } from './members-listing/members-listing.component';
import { EmailMembersComponent } from './email-members/email-members.component';


const routes: Routes = [
  {
    path : 'members-list',
    // component : MeetingRoomListComponent,
    children: [
      { path: '', component: MembersListingComponent },
      { path: 'member-details', component: MemberDetailsComponent },
      { path: 'email', component: EmailMembersComponent },
      
      // { path: 'add-employees', component: AddEmployeesComponent }
    ]
  }

];
@NgModule({
  declarations: [],
  imports: [
    RouterModule.forChild(routes),
    CommonModule
  ],
  exports: [RouterModule]
})
export class MembersRoutingModule { }
